import { ExternalLinkIcon } from 'lucide-react'
import { Link } from 'react-router'
import classNames from 'classnames'
import { IS_MOBILE_APP } from '@/constants'
import { MobileAppBridge } from '@/utils/mobileAppActions'

import './ExternalLink.scss'

interface LinkProps {
  children: React.ReactNode
  to: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
  className?: string
  hasIcon?: boolean
  variant?: 'dark' | 'light' | 'black'
  size?: 'default' | 'small'
  wrapped?: boolean
  maxLines?: number
  disabled?: boolean
}

function ExternalLink({
  children,
  to,
  onClick,
  className,
  hasIcon = true,
  variant = 'dark',
  size = 'default',
  wrapped = false,
  maxLines,
  disabled = false
}: LinkProps) {

  if (IS_MOBILE_APP) {
    return (
      <a
        className={classNames(
          'external-link',
          className,
          { [`external-link-${variant}`]: variant },
          { wrapped },
          { 'max-lines': maxLines },
          { disabled: !!disabled },
          { [`external-link-${size}`]: size }
        )}
        style={
          maxLines ? {
            ['--max-lines' as any]: maxLines
          } : undefined
        }
        onClick={() => MobileAppBridge.externalLink(to)}
      >
        {hasIcon && <ExternalLinkIcon size={18} />}
        <span>{children}</span>
      </a>
    )
  }

  return (
    <Link
      className={classNames(
        'external-link',
        className,
        { [`external-link-${variant}`]: variant },
        { wrapped },
        { 'max-lines': maxLines },
        { disabled: !!disabled },
        { [`external-link-${size}`]: size }
      )}
      style={
        maxLines ? {
          ['--max-lines' as any]: maxLines
        } : undefined
      }
      to={to}
      target='_blank'
      onClick={onClick}
    >
      {hasIcon && <ExternalLinkIcon size={18} />}
      <span>{children}</span>
    </Link>
  )
}

export default ExternalLink
